import React, { useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import { _ } from '../../common/utils/intl'
import { Grid, GridCol } from '../../common/ui-kit'
import { ContactHelp } from '../../common/modules/dash-board/ContactHelp'
import { EmployeeCtx } from '../EmployeeStore'
import { formatDateTime } from '../../common/utils/format'
import { appStore } from '../../common/AppStore'

export const DashboardHead = observer(() => {
  const currentEmployee = useContext(EmployeeCtx)
  const acccessData = appStore.getUserAccessFromId(currentEmployee.id)

  return (
    <Grid className="mb-xlarge">
      <GridCol size={{ m: 'fill' }} className="border-right">
        <Grid gutters="condensed">
          <GridCol size="fixed">
            <img src="/static/illustrations/profile-enduser-gray.svg" alt={_(t`User profile`)} />
          </GridCol>
          <GridCol size="auto" className="align-self-middle">
            <h1 className="h3 mb-tiny">
              <Trans>Vitajte,</Trans>
              <br />
              <>
                {acccessData && acccessData.name && <>{acccessData.name}</>}

                {!(acccessData && acccessData.name) && (
                  <>
                    {currentEmployee.last_name} {currentEmployee.first_name}
                  </>
                )}
              </>
            </h1>
            {acccessData?.last_date_of_login && (
              <div className="text-color-grey-600">
                <Trans>Posledné prihlásenie</Trans>:{' '}
                {formatDateTime(acccessData?.last_date_of_login)}
              </div>
            )}
          </GridCol>
        </Grid>
      </GridCol>
      {/* ie11 styles */}
      <GridCol size={{ m: 'fixed' }} style={{ flexBasis: '290px' }}>
        <hr className="border-light-grey hide-m" />
        <ContactHelp />
      </GridCol>
    </Grid>
  )
})
